module.exports = __webpack_public_path__ + "img/poster.e6e3282e.jpg";